export * from './myfriends.component';
